const excludeColumn = [
    "creation_log",
    "button",
    "last_updated",
    "formula",
    "progress",
    "item_id",
    "auto_number",
    "name",
    "subtasks"
  ];
  
export default excludeColumn;